<section id="regestration">
  <div class="row auth-height full-height-vh m-0">
    <div class="col-12 d-flex align-items-center justify-content-center">
      <div class="card max-width-900">
        <div class="card-content">
          <div class="card-header text-center pt-4 pb-3">
            <img alt="avtar" class="img-fluid" src="assets/logo-meander-black.png"
              width="300">
          </div>
          <div class="card-body">
            <div class="row justify-content-center">
              <aw-wizard #wizard [navBarLayout]="'large-empty-symbols'">
                <aw-wizard-step 
                awOptionalStep
                  [stepTitle]=""
                  [navigationSymbol]="{
                    symbol: '&#xf007;',
                    fontFamily: 'FontAwesome'
                  }"
                >
                <div class="card-body custom_input_for_media">
                  <form #personalForm="ngForm" class="editForm" novalidate>
                    <h4 class="head text-center">Student Information</h4>
                    <br />
                    <div class="row">
                      <div class="col-12">
                        <div class="row">
                          <div class="col-12 col-sm-6">
                            <div class="form-group">
                              <label class="form-control-label" for="name"
                                >Name<span class="required_field">*</span></label
                              >
                              <input
                                class="form-control input-md"
                                [(ngModel)]="enrolmentModel.name"
                                ngModel
                                #name="ngModel"
                                required
                                id="name"
                                name="name"
                                type="text"
                              #Name>
                              
                              <small
                                class="form-text text-muted danger"
                                *ngIf="
                                  !name.valid && (name.dirty || name.touched); else namemaxlength
                                "
                                >Name is required!</small
                              >
                              <ng-template #namemaxlength>
                                <small
                                class="form-text text-muted danger"
                                *ngIf="
                                enrolmentModel.name.length<4 && (name.dirty || name.touched)
                                "
                                >Minimum 4 Chars required!</small
                              >
                              </ng-template>
                            </div>
                          </div>
                          <div class='col-12 col-sm-6'>
                              <div class="form-group">
                                <label>College</label>
                                <ng-select
                                class="input_for_media_ng_select"
                                  [items]="collegeList"
                                  bindLabel="name"
                                  color="is_activated"
                                  bindValue="_id"
                                  placeholder="Select College"
                                  [(ngModel)]="selectedCollege"
                                  [ngModelOptions]="{ standalone: true }"
                                  (change)="getCollegeId($event)"
                                  >
                                <!-- <ng-template ng-header-tmp>
                                  <div>
                                    <button
                                      class="btn btn-link"
                                      (click)="openContent(1)"
                                    >
                                      Add New College
                                    </button>
                                  </div>
                                </ng-template> -->
                              </ng-select>
                              </div>
                          </div>
                          <div class="col-12 col-sm-6 ">
                            <div class="form-group">
                              <label class="form-control-label" for="email"
                                >Email<span class="required_field">*</span></label
                              >
                              <input
                                class="form-control input-md"
                                [(ngModel)]="enrolmentModel.email"
                                [formControl]="emailCheck"
                                ngModel
                                required
                                email
                                id="email"
                                name="email"
                                type="text"
                             #Email >
                              
                                
                              <small
                                class="form-text text-muted danger"
                                *ngIf="
                                !emailCheck.valid && (emailCheck.dirty || emailCheck.touched);
                                "
                                >Please enter a valid email!</small>
                                <!-- <ng-template>
                                  <small
                                class="form-text text-muted danger"
                                *ngIf="
                                  emailAlreadyExist 
                                "
                                >Email Already Exist! <a href="login" target="_blank">Click Here to Login</a></small
                              >
                           
                                </ng-template> -->
                                <!-- <small class="form-text text-muted danger"  *ngIf="emailAlreadyExist ">
                                  Email Already Exist! <a href="login" target="_blank">Click Here to Login</a>
                                </small> -->
                            </div>
                          </div>
                          <div class="col-12 col-sm-6">
                            <div class="form-group">
                              <label class="form-control-label" for="phone"
                                >Phone Number<span class="required_field">*</span></label
                              >
                              <div class="input-group">
                              <div class="input-group-prepend">
                                <span class="input-group-text" id="basic-addon1">+91</span>
                              </div>
                              <input
                                class="form-control input-md"
                                [(ngModel)]="enrolmentModel.phone"
                                ngModel
                                [formControl]="phoneCheck"
                                required
                                id="phone"
                                name="phone"
                                type="text" 
                                placeholder="e.g. 1234-567-890"  mask="0000-000-000" minlength="10"
                              />
                            </div>
                              <small
                                class="form-text text-muted danger"
                                *ngIf="
                                  !phoneCheck.valid && (phoneCheck.dirty || phoneCheck.touched);else phoneexist
                                "
                                >Please enter valid Phone number!</small
                              >
                              <ng-template #phoneexist>
                                <small
                                class="form-text text-muted danger"
                                *ngIf="
                                phoneAlreadyExist
                              "
                                >Phone number Already Exist! <a href="login" target="_blank">Click Here to Login</a></small
                              >
                              </ng-template>
                            </div>
                          </div>
                        </div>

                        <div   class="form-group text-center">
                          <button [disabled]="enrolmentModel.name.length<4 || !name.valid||!validateEmail(enrolmentModel.email) || !phoneCheck.valid || !emailPhoneValid"
                          type="button"
                          uiSref="work"
                          class="btn btn-info" awNextStep
                          (click)="checkEmailPhone(enrolmentModel.email,enrolmentModel.phone)">
                            Next
                            <span style="margin-left: 10px">
                              <i class="ft-chevron-right"></i>
                            </span>
                          </button>
                          <!-- <button id="tasks" #tasks style="display:none" type="button" [awGoToStep]="{stepIndex: 1}"></button> -->
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
                </aw-wizard-step>
                <aw-wizard-step
                [stepTitle]=""
                  [navigationSymbol]="{
                    symbol: '&#xf0b1;',
                    fontFamily: 'FontAwesome'
                  }"
                >
                <div class="card-body">
                  <form #learningInfoForm="ngForm" class="editForm" novalidate>
                    <h4 *ngIf="!isLogin_otp_step" class="head text-center">Learning Interest</h4>
                    <h4 *ngIf="isLogin_otp_step" class="head text-center otp-msg"> Hi We already have your record! <br>
                      <span *ngIf="login_otp_to_email">Please enter OTP sent to mailto: {{login_otp_to_email}}</span>
                       <span *ngIf="login_otp_to_phn">Please enter OTP sent to XXXXXX{{login_otp_to_phn}}</span> </h4>
                    <br />
                    <div class="row">
                      <div class="col-12">
                        <div class="row custom-width-form">
                          <div class="col-12" *ngIf="!isLogin_otp_step">
                            <div class="form-group custom-width">
                              <label class="form-control-label" for="interest">Category Interest<span class="required_field">*</span></label>
                              <ng-select
                                [items]="categoryList"
                                bindLabel="displayname"
                                bindValue="_id"
                                required
                                name="interest"
                                placeholder="Select Course Interest"
                                [(ngModel)]="selectedCategory"
                                #interest="ngModel"
                                [ngModelOptions]="{ standalone: true }"
                                (change)="getCategoryId($event)"> 
                              </ng-select>
                              <small
                              class="form-text text-muted danger"
                              *ngIf="
                                !interest.valid && (interest.dirty || interest.touched)
                              "
                              >Learning Interest required!</small>
                            </div>
                          </div>
                          <div class="col-12" *ngIf="!isLogin_otp_step">
                            <div class="form-group custom-width">
                              <label class="form-control-label" for="skills">Skills</label>
                              <ng-select
                                [items]="tagsList"
                                bindLabel="displayname"
                                bindValue="_id"
                                #skills="ngModel"
                                [multiple]="true"
                                [closeOnSelect]="false"
                                placeholder="Select Skill"
                                [(ngModel)]="selectedTag"
                                [ngModelOptions]="{ standalone: true }"
                                (change)="getTagsId($event)">
                            <small
                            class="form-text text-muted danger"
                            *ngIf="
                              !selectedTag
                            "
                            >Please fill at least one skill!</small
                          >
                              </ng-select>
                            </div>
                          </div>
                          <div class="col-12">
                            <div class="form-group custom-width">
                              <label>Where Did You Hear About Us</label>
                              <ng-select
                                [items]="event_type_list"
                                bindLabel="displayname"
                                bindValue="_id"
                                [closeOnSelect]="true"
                                placeholder="Select One"
                                [(ngModel)]="selected_type"
                                [ngModelOptions]="{ standalone: true }"
                                (change)="getTypeId($event)">
                              </ng-select>
                            </div>
                            
                          </div>
                          <div class="col-12">
                            <div class="form-group">
                              <label class="form-control-label"
                                >Qualification<span class="required_field">*</span></label
                              >
                              <input
                                class="form-control input-md"
                                [(ngModel)]="enrolmentModel.last_qualification"
                                ngModel
                                #name="ngModel"
                                required
                                id="last_qualification"
                                name="last_qualification"
                                type="text"
                                placeholder="Enter Qualification"
                              #last_qualification>
                              
                              <small
                                class="form-text text-muted danger"
                                *ngIf="
                                  !last_qualification.valid && (last_qualification.dirty || last_qualification.touched)
                                "
                                >Qualification is required!</small
                              >
                            </div>
                          </div>
                          <div class="col-12">
                            <div class="form-group">
                              <label class="form-control-label" for="course">Qualification Year<span class="required_field">*</span></label>
                              <ng-select
                                [items]="years_list"
                                bindLabel="year"
                                bindValue="year"
                                [closeOnSelect]="true"
                                placeholder="Select Year"
                                [(ngModel)]="selected_year"
                                [ngModelOptions]="{ standalone: true }"
                                (change)="getYear($event)">
                              </ng-select>
                            </div>
                          </div>
                          <div class="col-12" *ngIf="isLogin_otp_step">
                            <div class="form-group">
                              <label class="form-control-label otp">OTP</label>
                              <input
                                class="form-control input-md"
                                [(ngModel)]="login_otp"
                                required
                                id="otp"
                                name="otp"
                                type="number"
                                placeholder="Enter OTP"
                              >
                            </div>
                          </div>
                        </div>
                        <div class="form-group text-center">
                          <button *ngIf="activatedUser==null"
                            uiSref="work"
                            type="button"
                            class="btn btn-secondary screen_size_341px mr-1"
                            awPreviousStep
                          >
                            <span style="margin-right: 10px">
                              <i class="ft-chevron-left"></i>
                            </span>
                            Previous
                          </button>
                          <button *ngIf="!isLogin_otp_step" [disabled]="!learningInfoForm.valid || !enrolmentModel.last_qualification || !selected_year" 
                            uiSref="result"
                            (click)="submit()"
                            type="button"
                            class="btn btn-success"
                            
                            awResetWizard
                          >
                            Finish
                            <span style="margin-left: 10px">
                              <i class="ft-chevron-right"></i>
                            </span>
                          </button>
                          <button *ngIf="isLogin_otp_step" [disabled]="!learningInfoForm.valid || !enrolmentModel.last_qualification || !selected_year" 
                            uiSref="result"
                            (click)="loginOtpVerify()"
                            type="button"
                            class="btn btn-success"
                            
                            awResetWizard
                          >
                            Finish
                            <span style="margin-left: 10px">
                              <i class="ft-chevron-right"></i>
                            </span>
                          </button>
                        </div>
                        <div>
                          <button [disabled]="!enrolmentModel.last_qualification || !selected_year" class="btn btn-info btn-skip" (click)="submit()">Skip</button>
                        </div>
                      </div>
                    </div>
                  </form></div>
                </aw-wizard-step>
              </aw-wizard>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<div class="d-flex justify-content-between align-items-center">
  <ngx-spinner></ngx-spinner>
</div>